// import React, { useState, useEffect } from "react";
// import "./Banner.css"; // Importing the CSS file for custom styles
// import banner1 from "../banner/nn1.jpeg"; // Import your banner images
// import banner2 from "../banner/nn2.jpeg";
// import banner3 from "../banner/nn3.jpeg";

// const Banner = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   // Static banner images
//   const slides = [
//     { imageUrl: banner1 },
//     { imageUrl: banner2 },
//     { imageUrl: banner3 }
//   ];
  
//   const totalSlides = slides.length;

//   // Function to change slide
//   const changeSlide = (direction) => {
//     setCurrentSlide((prevSlide) => {
//       let newSlide = prevSlide + direction;
//       if (newSlide < 0) newSlide = totalSlides - 1;
//       if (newSlide >= totalSlides) newSlide = 0;
//       return newSlide;
//     });
//   };

//   // Auto-slide functionality
//   useEffect(() => {
//     const interval = setInterval(() => {
//       changeSlide(1);
//     }, 2000);
//     return () => clearInterval(interval); // Cleanup on unmount
//   }, []);

//   return (
//     <div className="banner-section">
//       <div className="slider">
//         <div
//           className="slides"
//           style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//         >
//           {slides.map((slide, index) => (
//             <div className="slide" key={index}>
//               <img src={slide.imageUrl} alt={`Slide ${index + 1}`} />
//             </div>
//           ))}
//         </div>
//         {/* Navigation Buttons */}
//         <button className="prev" onClick={() => changeSlide(-1)}>❮</button>
//         <button className="next" onClick={() => changeSlide(1)}>❯</button>
//       </div>
//     </div>
//   );
// };

// export default Banner;





import React, { useState, useEffect } from "react";
import "./Banner.css";
import banner1 from "../banner/nn1.jpeg";
import banner2 from "../banner/nn2.jpeg";
import banner3 from "../banner/nn3.jpeg";

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    { imageUrl: banner1 },
    { imageUrl: banner2 },
    { imageUrl: banner3 },
  ];

  const totalSlides = slides.length;

  // Manual slide change (buttons)
  const changeSlide = (direction) => {
    setCurrentSlide((prevSlide) => {
      let newSlide = prevSlide + direction;
      if (newSlide < 0) newSlide = totalSlides - 1;
      if (newSlide >= totalSlides) newSlide = 0;
      return newSlide;
    });
  };

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === totalSlides - 1 ? 0 : prevSlide + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [totalSlides]);

  return (
    <div className="banner-section">
      <div className="slider">
        <div
          className="slides"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div className="slide" key={index}>
              <img src={slide.imageUrl} alt={`Slide ${index + 1}`} />
            </div>
          ))}
        </div>

        <button className="prev" onClick={() => changeSlide(-1)}>❮</button>
        <button className="next" onClick={() => changeSlide(1)}>❯</button>
      </div>
    </div>
  );
};

export default Banner;
